import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertService, LoadingService } from '@shared/src/public-api';
import { BaseMaintenanceController } from '../_base/BaseMaintenanceController';
import { AddressStrongAddressItemMaintenanceDto } from './AddressStrongAddressItemMaintenanceDto';
import { AddressStrongAddressListMaintenanceDto } from './AddressStrongAddressListMaintenanceDto';

@Injectable()
export class AddressStrongAddressMaintenanceController extends BaseMaintenanceController<AddressStrongAddressListMaintenanceDto, AddressStrongAddressItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "addressstrongaddress");
    }

    public getResourceRoot(): string {
        return "ADDRESSSTRONGADDRESS";
    }

    public buildUrl(uri: string): string {
        return "internal/addressstrongaddress" + uri;
    }
}